export const animationTime = (ms = 100) =>
  new Promise((res) => setTimeout(res, ms));
